<template>
<!--  <v-card class="editor-tab">-->
  <div>
    <e-c-shacl-level
      label="SHACL Shape Model"
    >
      <p class="mb-0">Please select a SHACL shape model for the validation. For more information click <a :href="methodologyShaclLevelsUrl" target="_blank" style="text-decoration: underline;">here</a>.</p>
    </e-c-shacl-level>
    <e-c-select
      :options="items"
      v-model="type"
      label="Validating"
      class="mt-5 mb-2 selector"
    />
    <v-card-text class="pt-0 px-0">
      <codemirror
        v-model="code"
        class="api-editor"
        :options="cmOptions"
        @input="onCmChange"
      />
    </v-card-text>
    <v-row>
      <v-col
          class="shacl-validator-button-wrapper"
          cols="12"
      >
        <div class="d-flex">
          <e-c-button
              :primary="true"
              :disabled="$store.state['violations'].isLoading"
              :action="() => $emit('validate-schema', code, type)"
              label="Validate"
              class="mr-5"
          />
          <e-c-button
              :action="loadExample"
              label="Load Example"
          />
        </div>
      </v-col>
    </v-row>
  </div>
<!--  </v-card>-->
</template>

<script>
import { codemirror } from 'vue-codemirror';

import EXAMPLE_CODE from '@/assets/SHACL_violations.json';

// import base style
import 'codemirror/lib/codemirror.css';

// Syntax highlighting
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/yaml/yaml';

// Linting
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/yaml-lint';
import 'codemirror/addon/lint/json-lint';

// Additional resources
import 'codemirror/addon/selection/active-line';
import ECButton from "@/components/widgets/ECButton";
import ECSelect from "@/components/widgets/ECSelect";
import ECShaclLevel from '@/components/widgets/ECShaclLevel';

export default {
  name: 'EditorTab',
  components: {
    ECSelect,
    ECButton,
    codemirror,
    ECShaclLevel
  },
  props: {
    editorModel: {
      type: Object,
      default: () => ({
        code: '',
        type: 'application/ld+json'
      })
    }
  },
  data() {
    return {
      type: this.editorModel.type,
      code: this.editorModel.code,
      items: [
        'application/ld+json',
        'application/rdf+xml',
        'application/n-triples',
        'application/trig',
        'text/turtle',
        'text/n3',
        'text/plain',
      ],
      exampleCode: JSON.stringify(EXAMPLE_CODE),
      cmOptions: {
        tabSize: 4,
        mode: 'text/x-yaml',
        theme: 'default',
        lineNumbers: true,
        line: true,
        lint: false,
        styleActiveLine: true,
        foldGutter: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-lint-markers',
          'CodeMirror-foldgutter',
        ],
      },
      methodologyShaclLevelsUrl:  window.location.origin + '/mqa/methodology#shacl-levels',
    };
  },
  methods: {
    // Returns true, if code is json-like
    isJson(code) {
      const jsonRegex = /^[ \r\n\t]*[{[]/;
      return jsonRegex.test(code);
    },
    onCmChange() {
      // Reactively swap syntax highlighting and linting depending
      this.cmOptions.mode = this.isJson(this.code) ? 'application/json' : 'text/x-yaml';
    },
    loadExample() {
      this.code = this.exampleCode;
      this.type = 'application/ld+json';
    },
  },
  watch: {
    editorModel(newModel) {
      this.type = newModel.type;
      this.code = newModel.code;
    }
  }
};
</script>

<style lang="scss">

  .CodeMirror {
    border: 1px solid rgba(0,0,0,.125);
    //border-top: 1px solid rgba(0,0,0,.125);
    //height: unset;
    height: 400px;
    //max-height: 800px;
  }
  //.CodeMirror-scroll {
  //  height: unset;
  //  min-height: 200px;
  //}
  .selector {
    width: 60%;
  }
</style>
